import { useEffect, useState } from "react"

/**
 * The browser's geolocation permission ("granted", "prompt" or "denied"),
 * kept current when the user changes it in the browser. "unknown" when the
 * Permissions API can't report it (the browser then decides on first use).
 * @returns {"granted"|"prompt"|"denied"|"unknown"}
 */
export function useGeolocationPermission() {
    const [state, setState] = useState("unknown")

    useEffect(() => {
        if (!navigator.permissions?.query) return

        let status = null
        let cancelled = false
        const onChange = () => setState(status.state)

        navigator.permissions
            .query({ name: "geolocation" })
            .then((result) => {
                if (cancelled) return
                status = result
                setState(result.state)
                result.addEventListener("change", onChange)
            })
            .catch(() => {})

        return () => {
            cancelled = true
            status?.removeEventListener("change", onChange)
        }
    }, [])

    return state
}
